import { Alert, Button, FilterDropdown, Input, List, Radio, ShowButton, Space, Table, Tag } from '@pankod/refine-antd'
import { useEffect, useRef, useState } from 'react'
import { currency, formatDateTime, supabaseClient } from 'utility'
import { AuditFinding, correctAuditFinding, readAuditFindings } from './auditFindings'

const labels: Record<string, string> = {
  ARTICULO_NO_COMPRADO: 'Artículo no comprado',
  CUPON_NO_ABONADO: 'Cupón no abonado',
  SUPLEMENTO_INDEBIDO: 'Suplemento indebido',
  SUBIDA_NO_COBRADA: 'Subida no cobrada',
  OTROS: 'Otros'
}
export const AuditFindingsList = ({ active }: { active: boolean }) => {
  const [rows, setRows] = useState<AuditFinding[]>([])
  const [status, setStatus] = useState<'OPEN' | 'CORRECTED'>('OPEN')
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState<string | null>(null)
  const [error, setError] = useState('')
  const generation = useRef(0)
  const load = async () => {
    const current = ++generation.current
    setLoading(true)
    try {
      const result = await readAuditFindings(supabaseClient, status)
      if (current === generation.current) { setRows(result); setError('') }
    } catch (e) { if (current === generation.current) setError((e as Error).message) } finally { if (current === generation.current) setLoading(false) }
  }
  useEffect(() => {
    if (!active) return
    load()
    const timer = setInterval(() => { load() }, 60000)
    return () => { generation.current++; clearInterval(timer) }
  }, [active, status])
  const correct = async (row: AuditFinding) => {
    setSaving(row.finding_id)
    try { await correctAuditFinding(supabaseClient, row.finding_id); await load() } catch (e) { setError((e as Error).message) } finally { setSaving(null) }
  }
  const textFilter = (field: keyof AuditFinding, display?: (row: AuditFinding) => string) => ({
    filterDropdown: (props: any) => <FilterDropdown {...props}><Input placeholder='Buscar' value={String(props.selectedKeys[0] || '')} onChange={e => props.setSelectedKeys(e.target.value ? [e.target.value] : [])} /></FilterDropdown>,
    onFilter: (value: any, row: AuditFinding) => String(display ? display(row) : row[field] ?? '').toLocaleLowerCase().includes(String(value).toLocaleLowerCase()),
    sorter: (a: AuditFinding, b: AuditFinding) => String(a[field] ?? '').localeCompare(String(b[field] ?? ''), 'es', { numeric: true })
  })
  return <List title='Auditoría' headerButtons={<Space><Radio.Group value={status} onChange={e => setStatus(e.target.value)}><Radio.Button value='OPEN'>Abiertos</Radio.Button><Radio.Button value='CORRECTED'>Corregidos</Radio.Button></Radio.Group><Button onClick={() => { load() }} loading={loading}>Actualizar</Button></Space>}>
    {error && <Alert type='error' showIcon message={error} style={{ marginBottom: 12 }} />}
    <Table<AuditFinding> dataSource={rows} rowKey='finding_id' loading={loading} pagination={{ defaultPageSize: 10, showSizeChanger: true }} scroll={{ x: 1100, y: '60vh' }}>
      <Table.Column<AuditFinding> title='Pedido' dataIndex='order_id' width={110} {...textFilter('order_id')} render={value => <Space>{value}<ShowButton resourceNameOrRouteName='orders' recordItemId={value} hideText size='small' /></Space>} />
      <Table.Column<AuditFinding> title='Tienda' dataIndex='store' width={140} {...textFilter('store')} />
      <Table.Column<AuditFinding> title='Tipo' dataIndex='kind' width={160} {...textFilter('kind', row => labels[row.kind] || row.kind)} render={value => labels[value] || value} />
      <Table.Column<AuditFinding> title='Detalle' dataIndex='detail' {...textFilter('detail')} render={value => <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{value}</div>} />
      <Table.Column<AuditFinding> title='Importe' dataIndex='amount_minor' width={110} {...textFilter('amount_minor', row => (row.amount_minor / 100).toFixed(2))} render={value => currency(value / 100)} />
      <Table.Column<AuditFinding> title='Pedido tienda' dataIndex='brand_order_ref' width={140} {...textFilter('brand_order_ref')} />
      <Table.Column<AuditFinding> title='Detectado' dataIndex='detected_at' width={155} {...textFilter('detected_at', row => formatDateTime(row.detected_at, true))} render={value => formatDateTime(value, true)} />
      <Table.Column<AuditFinding> title='Acciones' width={125} render={(_, row) => row.status === 'OPEN' ? <Button disabled={saving !== null || loading || !!error} loading={saving === row.finding_id} onClick={() => { correct(row) }}>Corregido</Button> : <Tag color='green'>Corregido</Tag>} />
    </Table>
  </List>
}
